<div class="gpd-full-page gt-full-router dt-view" style="display: flex; gap: 12px">
  <div *ngIf="tables.length != 0" class="gpd-container-header">
      <dx-select-box
          [items]="tables"
          [(value)]="tableId"
          displayExpr="title"
          valueExpr="id"
          itemTemplate="item"
          (onItemClick)="tableSelectChanged($event)"
          class="gpd-input"
          i18n-placeholder="@@selectTable"
          placeholder="Select a table"
        >
          <div *dxTemplate="let table of 'item'" class="dt-table-item">
            <div class="dt-shared-icon-slot">
              <app-svg-icon
                *ngIf="isShared(table)"
                [id]="'dt-shared-icon-' + table.id"
                icon="user-multiple"
                [size]="16"
                color="var(--primary-color)"
                class="dt-shared-icon"
              ></app-svg-icon>
              <dx-popover
                *ngIf="isShared(table)"
                [target]="'#dt-shared-icon-' + table.id"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="top"
              >
                <div class="help-context" i18n="@@shared">Shared</div>
              </dx-popover>
            </div>
            <div class="dt-table-item-labels">
              <b>{{ table.title }}</b>
              <span class="dt-table-item-creator">{{ creatorLabel(table) }}</span>
            </div>
            <div *ngIf="isShared(table) && !isMine(table)" class="dt-leave-icon-slot">
              <app-svg-icon
                [id]="'dt-leave-icon-' + table.id"
                icon="exit"
                [size]="18"
                color="#C20909"
                class="dt-leave-icon"
                (click)="openLeaveConfirm(table, $event)"
              ></app-svg-icon>
              <dx-popover
                [target]="'#dt-leave-icon-' + table.id"
                showEvent="mouseenter"
                hideEvent="mouseleave"
                [wrapperAttr]="{ class: 'gpd-popover' }"
                position="top"
              >
                <div class="help-context" i18n="@@leaveTable">Leave Table</div>
              </dx-popover>
            </div>
          </div>
        </dx-select-box>
    <div class="gt-flex-direction-row gt-align-items-center" style="display: flex; gap: 8px">
      
      <app-gpd-button i18n-text="@@newTable" text="New table" icon="add" (onClick)="createTable()"></app-gpd-button>
    </div>
  </div>
  <div *ngIf="tables.length == 0 && tableId == null" class="gpd-inner-page">
    <div class="gpd-container no-tables-container" style="justify-content: end">
      <app-gpd-button i18n-text="@@newTable" text="New table" icon="add" (onClick)="createTable()"></app-gpd-button>
    </div>
  </div>
  <div *ngIf="tableId != null && tables.length != 0" class="gpd-full-page gpd-inner-page">
    <div class="gpd-container-header">
      <div class="gpd-header-section">
        <dx-text-box
          class="gpd-input"
          valueChangeEvent="keyup"
          mode="search"
          i18n-placeholder="@@dynamicTableSearch"
          placeholder="Search in table..."
          [showClearButton]="true"
          (onValueChanged)="grid.instance.searchByText($event.value)"
        ></dx-text-box>
      </div>
      <div class="gpd-header-section">
        <app-gpd-button
          i18n-text="@@export"
          type="tertiary"
          text="Export"
          icon="download"
          (onClick)="exportTable()"
        ></app-gpd-button>
        <app-gpd-button
          type="text"
          icon="heart"
          color="var(--color-grey-800)"
          [iconColor]="selectedTable?.isDefault ? 'var(--primary-color)' : 'var(--primary-color)'"
          [iconFill]="selectedTable?.isDefault ? 'var(--primary-color)' : 'transparent'"
          (onClick)="toggleDefault()"
        ></app-gpd-button>
        <app-gpd-button
          type="text"
          icon="copy"
          i18n-hint="@@duplicateTable"
          hint="Duplicate table"
          (onClick)="openDuplicatePopup()"
        ></app-gpd-button>
        <app-gpd-button
        *ngIf="selectedTable?.canEdit"
        type="text"
        icon="edit"
        (onClick)="editTable()"
      ></app-gpd-button>
        
      </div>
    </div>
    <div class="gpd-full-page gpd-container">
      <div *ngIf="fieldErrors.length > 0" class="dt-field-error-banner">
        <span i18n="@@someColumnsFailedToLoad">Some columns could not be loaded:</span>
        <ul>
          <li *ngFor="let e of fieldErrors">
            <strong>{{ e.displayName }}</strong
            >: {{ e.message }}
          </li>
        </ul>
      </div>
      <div class="gpd-full-page">
        <dx-data-grid
          #grid
          class="gpd-datagrid gpd-datagrid-slim"
          [dataSource]="$safeNavigationMigration(table?.data)"
          height="100%"
          [allowColumnReordering]="true"
          [rowAlternationEnabled]="true"
          [wordWrapEnabled]="true"
          useNative="false"
          showScrollbar="always"
          [allowColumnResizing]="true"
          columnResizingMode="widget"
          [showBorders]="true"
          [hoverStateEnabled]="true"
          [columnAutoWidth]="true"
          (onRowClick)="onProjectClick($event)"
          height="100%"
        >
          <dxo-selection mode="single"></dxo-selection>
          <dxo-paging [enabled]="false"> </dxo-paging>
          <dxo-sorting mode="multiple"></dxo-sorting>
          <dxo-header-filter [visible]="filterVisible"></dxo-header-filter>
          <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
          <dxi-column
            *ngFor="let field of table?.structure"
            [allowResizing]="true"
            [dataField]="field.fieldIdentifier"
            [caption]="field.displayName"
            cellTemplate="cellTemplate"
            [calculateCellValue]="calculateCellValue"
          >
            <dxi-column
              *ngFor="let field of field?.fields"
              [allowResizing]="true"
              [allowFiltering]="true"
              alignment="left"
              [dataField]="field.fieldIdentifier"
              [caption]="field.displayName"
              cellTemplate="cellTemplate"
              [calculateCellValue]="calculateCellValue"
            >
            </dxi-column>
            <div *dxTemplate="let data of 'cellTemplate'">
              @if (data.data[data.column.dataField]?.value != null) {
                @switch (data.data[data.column.dataField]?.type) {
                  @case ('document') {
                    @if(data.data[data.column.dataField]?.displayValue) {
                    <app-document-pill
                      *ngIf="data.data[data.column.dataField].displayValue"
                      [fileViewerRef]="fileViewer"
                      [value]="toDocumentPillValue(data.data[data.column.dataField])"
                      (click)="$event.stopPropagation()"
                    ></app-document-pill>
                    }@else {
                      -
                    }
                  }
                  @case ('contact') {
                    <app-contact-pill
                      [value]="toContactPillValue(data.data[data.column.dataField])"
                      (click)="$event.stopPropagation()"
                    ></app-contact-pill>
                  }
                  @case ('contract') {
                    <app-contracts-pill
                      [editable]="false"
                      [content]="toContractPillValue(data.data[data.column.dataField])"
                      [linkType]="'contract'"
                      (click)="$event.stopPropagation()"
                    ></app-contracts-pill>
                  }
                  @default {
                    {{ data.data[data.column.dataField]?.displayValue }}
                  }
                }
              } @else {
                -
              }
            </div>
          </dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </div>
</div>

<ng-template #cellTemplate let-data>
  <div class="gt-cell-content">
    @if (data.data[data.column.dataField]?.value != null) {
      @switch (data.data[data.column.dataField]?.type) {
        @case ('document') {
          <app-document-pill
            [fileViewerRef]="fileViewer"
            [value]="toDocumentPillValue(data.data[data.column.dataField])"
          ></app-document-pill>
        }
        @case ('contact') {
          <app-contact-pill [value]="toContactPillValue(data.data[data.column.dataField])"></app-contact-pill>
        }
        @case ('contract') {
          <app-contracts-pill
            [editable]="false"
            [content]="toContractPillValue(data.data[data.column.dataField])"
            [linkType]="'contract'"
          ></app-contracts-pill>
        }
        @default {
          {{ data.data[data.column.dataField]?.displayValue }}
        }
      }
    } @else {
      {{ data.data[data.column.dataField]?.displayValue }}
    }
  </div>
</ng-template>

<app-file-viewer #fileViewer></app-file-viewer>

<app-generic-popup
  [(visible)]="leavePopupVisible"
  title="Leave Table"
  i18n-title="@@leaveTable"
  titleIcon="alert"
  [content]="leaveTableConfirmMessage"
  width="478px"
  [leftButtons]="[]"
  [buttons]="leaveTableButtons"
  (onHiding)="cancelLeaveTable()"
></app-generic-popup>

<app-generic-popup
  [(visible)]="duplicatePopupVisible"
  title="Duplicate Table"
  i18n-title="@@duplicateTableTitle"
  width="420px"
  [allowOutsideClick]="false"
  [buttons]="duplicateTableButtons"
>
  <div class="dt-duplicate-field">
    <label class="dt-duplicate-label" i18n="@@tableNameLabel">Table name <span class="required-marker">*</span></label>
    <dx-text-box
      [(value)]="duplicateTitle"
      [showClearButton]="true"
      valueChangeEvent="keyup"
      (onValueChanged)="updateDuplicateButtonState()"
    ></dx-text-box>
  </div>
</app-generic-popup>

<app-validation-toast #successToast></app-validation-toast>
